import { RegistereRibbonButton, useAppInfo, useModelDrivenApp, useRibbon, WorkFlowDialog, RegisterWorkflowRibbonButton } from "@eavfw/apps";

RegisterWorkflowRibbonButton("CUSTOM_SYNC_RANKEDIN", { text: "Sync RankedIn", title: "Sync Rankedin", workflow: "FetchRankedInTournamentWorkflow" });
RegisterWorkflowRibbonButton("CUSTOM_CALC_RANKING_SCORES", { text: "Calc Scores", title: "Calc Scores", workflow: "ComputeRankingScoresWorkflow" });
